module.exports = __webpack_public_path__ + "img/tpg-logo.2ef2ab72.png";